import { IUserCredential } from 'src/context/global/types';

// Default admin user with pre-computed hash for "admin:password"
// This matches the existing configuration in get-configuration.ts
export const getDefaultUserCredentials = (): IUserCredential[] => [
  {
    id: 'default_admin',
    name: 'admin',
    passwordHash:
      '0614862976da6450e770d00f6d75d890b3e0585d3cc75204c20507804ad5da654f65e1fe32b0d2cc83c97d5b159f0b196ac723caea2a7433360f1f4f8da95524',
    salt: 'ee26b0dd4af7e749aa1a8ee3c10ae9923f618980772e473f8819a5d4940e0db27ac185f8a0e1d5f84f88bc887fd67b143732c304cc5fa9ad8e6f57f50028a8ff',
    level: 0,
  },
];

// Helper function to ensure there's always at least one user (the default admin)
export const ensureDefaultUsers = (
  userCredentials?: IUserCredential[],
): IUserCredential[] => {
  if (!userCredentials || userCredentials.length === 0) {
    return getDefaultUserCredentials();
  }
  return userCredentials;
};
